module.exports = __webpack_public_path__ + "media/Great_granddaughter.d88370a4.mp3";